import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { PagesComponent } from './pages/pages.component';
import { AuthorizatedGuard } from 'src/guards/authorizated.guard';
import { NotFoundComponent } from './common/not-found/not-found.component';
import { MailboxComponent } from './mailbox/mailbox.component';
import { ResetPassComponent } from './login/reset-pass/reset-pass.component';
import { ResetPassFormComponent } from './login/reset-pass-form/reset-pass-form.component';
import { SearchProfileComponent } from './searchProfile/search-profile.component';
import { selectorActividadVulnerableResolver } from './resolvers/selector-actividad-vulnerable.resolver';
const routes: Routes = [
  { path: '', redirectTo: 'v2', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'mailbox', component: MailboxComponent },
  { path: 'login/resetpass', component: ResetPassComponent },
  { path: 'login/updatepass', component: ResetPassFormComponent },
  {
    path: 'v2/search-profile',
    component: SearchProfileComponent,
    canActivate: [AuthorizatedGuard],
    resolve:{
      actividadesVulnerables:selectorActividadVulnerableResolver
    }
  },
  {
    path: 'v2',
    component: PagesComponent,
    canActivate: [AuthorizatedGuard],
    loadChildren: () =>
      import('./pages/pages.module').then(m => m.PagesModule),
  },
  { path: '**', component: NotFoundComponent }
];


@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
